export default "__VITE_PUBLIC_ASSET__bda221be__"